// import ChatLandingScreen from "./ChatLandingPage";
import { useEffect, useState, useContext } from "react";
import { getClients } from "./Utilities/tokenUtility";
import { BackendDataContext } from "./Utilities/BackendDataContext";
import { getChats } from "./Utilities/tokenUtility";
import SimpleBar from "simplebar-react";
import "./AdminChatLogs.scss";
import {  GiHamburgerMenu } from "react-icons/gi";

const availableSources = [
    {
        name: 'textToChat',
        icon: '💬',
        label: 'Text to Chat'
    },
    {
        name: 'web_mobile',
        icon: '📱💻',
        label: 'Mobile Web'
    },
    {
        name: 'web_desktop',
        icon: '💻',
        label: 'Desktop Web'
    },
    {
        name: 'mobile_app',
        icon: '📲',
        label: 'Mobile App'
    }
]

const Admin = () => {

    

        const [clients, setClients] = useState([]);
        const [selectedClient, setSelectedClient] = useState(null);
        const { setChats } = useContext(BackendDataContext);

        const [isAllowed, setIsAllowed] = useState(false);
        const [pass, setPass] = useState("");
        

        useEffect(() => {
            const fetchClients = async () => {
                try {
                    const response = await getClients()
                    setClients(response.clients || []);
                } catch (error) {
                    console.error("Error fetching clients:", error);
                }
            };

            if (isAllowed) {
                fetchClients();
            }
        }, [isAllowed]);



        useEffect(() => {

            console.log("Selected client changed:", selectedClient);

            if (selectedClient && isAllowed) {

                const fetchChats = async () => {
                    try {
                        const response = await getChats(selectedClient.ClientID)
                        const newChats = response.chats?.map(chat => {

                            let content = chat.Content;
                            let unAuthedApis = [];
                            let responses = []

                            try {
                                let contentJSON = JSON.parse(chat.Content);
                                content = contentJSON.message
                                unAuthedApis = contentJSON.unAuthedApis || [];
                                responses = contentJSON.responses || [];
                            } catch (e) {
                                // console.error("Failed to parse chat content:", e);
                            }
                            
                            return {
                                role: chat.Role,
                                content: content,
                                unAuthedApis: unAuthedApis,
                                responses: responses,
                                timestamp: chat.TimestampUTC,
                                Source: chat.Source
                            }
                        })

                        console.log("Fetched chats:", newChats);

                        setChats(newChats.reverse() || []);
                    } catch (error) {
                        console.error("Error fetching chats:", error);
                        setChats([]);
                    }
                }

                fetchChats();

            } else if (!selectedClient) {
                setChats([]);
            }

        }, [selectedClient, setChats, isAllowed])


    const [isMobile, setIsMobile] = useState(window.innerWidth < 800);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 800);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    const [clientsListIsColapsed, setClientsListIsCollapsed] = useState(false);

    const [clientFilter, setClientFilter] = useState("");


    if (!isAllowed) {
        return (
            <div className="chat-logs-container">
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                    background: "var(--bg)",
                    padding: "20px"
                }}>
                    <div style={{
                        background: "var(--card)",
                        border: "1px solid var(--border)",
                        borderRadius: "14px",
                        padding: "32px",
                        boxShadow: "0 8px 32px rgba(100,116,139,0.10)",
                        width: "100%",
                        maxWidth: "400px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px",
                        alignItems: "center"
                    }}>
                        <h2 style={{
                            color: "var(--accent)",
                            margin: "0 0 8px 0",
                            fontSize: "24px",
                            fontWeight: "700",
                            textAlign: "center"
                        }}>
                            Admin Access
                        </h2>
                        
                        <p style={{
                            color: "var(--muted)",
                            margin: "0 0 16px 0",
                            textAlign: "center",
                            fontSize: "14px"
                        }}>
                            Enter your admin password to access the dashboard
                        </p>

                        <input
                            value={pass}
                            onChange={(e) => setPass(e.target.value)}
                            type="password"
                            placeholder="Enter admin password"
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    document.querySelector('[data-admin-login]').click();
                                }
                            }}
                            style={{
                                width: "100%",
                                padding: "12px 16px",
                                border: "1px solid var(--border)",
                                borderRadius: "8px",
                                fontSize: "14px",
                                background: "var(--bg)",
                                color: "var(--text)",
                                outline: "none",
                                transition: "border-color 0.2s ease"
                            }}
                        />

                        <button 
                            data-admin-login
                            onClick={() => {
                                fetch("https://functionappfordev.azurewebsites.net/api/internalDashHandler", {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                        "X-UserSessionID": localStorage.getItem('UserSessionID') || ''
                                    },
                                    body: JSON.stringify({ action: 'CHECK_PASS', adminPass: pass })
                                })
                                    .then(response => response.json())
                                    .then(response => {
                                        if (response.isMatch) {
                                            setIsAllowed(true);
                                        } else {
                                            throw new Error('Failed to allow admin access');
                                        }
                                    })
                                    .catch(error => {
                                        console.error("Error allowing admin access:", error);
                                        alert("Incorrect password. Please try again.");
                                    }
                                );
                            }} 
                            style={{
                                width: "100%",
                                padding: "12px 24px",
                                background: "var(--user)",
                                color: "white",
                                border: "none",
                                borderRadius: "8px",
                                fontSize: "16px",
                                fontWeight: "600",
                                cursor: "pointer",
                                transition: "all 0.2s ease"
                            }}
                        >
                            Access Dashboard
                        </button>
                    </div>
                </div>
            </div>
        )
    }




    return (
        <div style={{width: "100vw", height: "100vh", display: "flex", flexDirection: "column", background: "#f8fafc"}}>
            {/* Sidebar or Floating Popup/Button */}
            {/* <div style={{width: "100%", border: "1px solid red", height: "100px"}}> */}
                {isMobile ? (
                clientsListIsColapsed ? (
                    <div style={{width: "100%", display: "flex", flexDirection: "row", justifyContent: "flex-end", alignItems: "center", height: "125px", background: "white",
                        padding: "10px"
                    }}>
                    <button
                        onClick={() => setClientsListIsCollapsed(false)}
                        style={{
                            // position: "fixed",
                            // top: "20px",
                            // right: "20px",
                            // transform: "translateX(-50%)",
                            zIndex: 1200000000,
                            background: "linear-gradient(90deg, #6366f1 0%, #60a5fa 100%)",
                            color: "#fff",
                            border: "none",
                            borderRadius: "50px",
                            boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
                            padding: "20px 20px",
                            fontWeight: 600,
                            fontSize: "18px",
                            letterSpacing: "0.5px",
                            cursor: "pointer",
                            transition: "background 0.2s",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "20px"
                        }}
                    >
                        {/* Show Clients */}
                        <GiHamburgerMenu />

                    </button>
                     </div>
                ) : (
                    <div
                        style={{
                            position: "fixed",
                            height: "80vh",
                            top: "20px",
                            left: "50%",
                            transform: "translateX(-50%)",
                            zIndex: 12000000000,
                            width: "92vw",
                            maxWidth: "420px",
                            background: "#fff",
                            border: "1.5px solid #e5e7eb",
                            borderRadius: "18px",
                            boxShadow: "0 8px 32px rgba(100,116,139,0.10)",
                            padding: "22px 20px 18px 20px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "18px",



                        }}
                    >
                        <div style={{width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                            <span style={{fontWeight: 700, fontSize: "18px", color: "#334155"}}>
                                {`Selected Client: `}
                                <span style={{color: "#6366f1"}}>
                                    {selectedClient ? selectedClient.Name : "None"}
                                </span>
                            </span>

                            <button
                                onClick={() => setClientsListIsCollapsed(true)}
                                style={{
                                    background: "none",
                                    border: "none",
                                    color: "#64748b",
                                    fontSize: "22px",
                                    cursor: "pointer",
                                    fontWeight: 700,
                                    padding: "0 8px"
                                }}
                                aria-label="Collapse"
                                title="Collapse"
                            >
                                ×
                            </button>
                        </div>


                                                    <input
                                type="text"
                                placeholder="Filter clients..."
                                style={{
                                    marginRight: "12px",
                                    padding: "6px 10px",
                                    borderRadius: "6px",
                                    border: "1px solid #e5e7eb",
                                    fontSize: "15px",
                                    outline: "none"
                                }}
                                value={clientFilter || ""}
                                onChange={e => setClientFilter(e.target.value)}
                            />


                        <SimpleBar style={{flex: "1", minHeight: "0", width: "100%",}}>
                        <ul style={{width: "100%", margin: 0, padding: 0, listStyle: "none"}}>
                            {clients
                            .filter(client => client.Name.toLowerCase().trim().includes(clientFilter.toLowerCase().trim()))
                                .sort((a, b) => a.CompanyID - b.CompanyID)
                                .map(client => (
                                    <li key={client.ClientID}
                                        style={{
                                            cursor: "pointer",
                                            padding: "10px 14px",
                                            borderRadius: "8px",
                                            background: selectedClient?.ClientID === client.ClientID ? "linear-gradient(90deg, #6366f1 0%, #60a5fa 100%)" : "transparent",
                                            color: selectedClient?.ClientID === client.ClientID ? "#fff" : "#334155",
                                            fontWeight: selectedClient?.ClientID === client.ClientID ? 600 : 500,
                                            marginBottom: "6px",
                                            transition: "background 0.15s, color 0.15s"
                                        }}
                                        onClick={() => setSelectedClient(client)}>
                                        {client.Name}
                                    </li>
                                ))}
                        </ul>
                        </SimpleBar>
                    </div>
                )
            ) : (
                clientsListIsColapsed ? (
                    <button
                        onClick={() => setClientsListIsCollapsed(false)}
                        style={{
                            position: "fixed",
                            top: "22px",
                            right: "32px",
                            zIndex: 12000000,
                            background: "linear-gradient(90deg, #6366f1 0%, #60a5fa 100%)",
                            color: "#fff",
                            border: "none",
                            borderRadius: "50px",
                            boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
                            padding: "14px 32px",
                            fontWeight: 600,
                            fontSize: "18px",
                            letterSpacing: "0.5px",
                            cursor: "pointer",
                            transition: "background 0.2s"
                        }}
                    >
                        Show Clients
                    </button>
                ) : (
                    <div style={{
                        width: "320px",
                        height: "100%",
                        overflowY: "auto",
                        borderRight: "2px solid #e5e7eb",
                        background: "#fff",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "18px",
                        padding: "24px 18px 18px 18px",
                        boxShadow: "2px 0 16px rgba(100,116,139,0.04)",
                        position: "absolute",
                        zIndex: "100000000"
                    }}>
                        <div style={{width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                            <span style={{fontWeight: 700, fontSize: "18px", color: "#334155"}}>
                                {`Selected Client: `}
                                <span style={{color: "#6366f1"}}>
                                    {selectedClient ? selectedClient.Name : "None"}
                                </span>
                            </span>
                            <button
                                onClick={() => setClientsListIsCollapsed(true)}
                                style={{
                                    background: "none",
                                    border: "none",
                                    color: "#64748b",
                                    fontSize: "22px",
                                    cursor: "pointer",
                                    fontWeight: 700,
                                    padding: "0 8px"
                                }}
                                aria-label="Collapse"
                                title="Collapse"
                            >
                                ×
                            </button>
                        </div>


                                                    <input
                                type="text"
                                placeholder="Filter clients..."
                                style={{
                                    marginRight: "12px",
                                    padding: "6px 10px",
                                    borderRadius: "6px",
                                    border: "1px solid #e5e7eb",
                                    fontSize: "15px",
                                    outline: "none"
                                }}
                                value={clientFilter || ""}
                                onChange={e => setClientFilter(e.target.value)}
                            />
                        <ul style={{width: "100%", margin: 0, padding: 0, listStyle: "none"}}>
                            {clients
                                .filter(client => client.Name.toLowerCase().trim().includes(clientFilter.toLowerCase().trim()))
                                .sort((a, b) => a.CompanyID - b.CompanyID)
                                .map(client => (
                                    <li key={client.ClientID}
                                        style={{
                                            cursor: "pointer",
                                            padding: "10px 14px",
                                            borderRadius: "8px",
                                            background: selectedClient?.ClientID === client.ClientID ? "linear-gradient(90deg, #6366f1 0%, #60a5fa 100%)" : "transparent",
                                            color: selectedClient?.ClientID === client.ClientID ? "#fff" : "#334155",
                                            fontWeight: selectedClient?.ClientID === client.ClientID ? 600 : 500,
                                            marginBottom: "6px",
                                            transition: "background 0.15s, color 0.15s"
                                        }}
                                        onClick={() => setSelectedClient(client)}>
                                        {client.Name}
                                    </li>
                                ))}
                        </ul>
                    </div>
                )
            )}

{/* 
            </div> */}
            <div style={{flex: "1", minWidth: "0", height: "100%"}}>
                {selectedClient ? (
                    <ChatLogsDisplay clientId={selectedClient.ClientID} clientName={selectedClient.Name} isMobile={isMobile} />
                ) : (
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        color: "#6b7280",
                        fontSize: "16px"
                    }}>
                        Select a client to view their chat logs
                    </div>
                )}
            </div>
        </div>
    )

}

// API icon mapping
const API_ICON = {
    crm: '/assets/DealCompass_Initials_BlueLetters_TransparentBg_clipped_rev_1.png',
    google: '/assets/google-calendar-icon.png',
    outlook: '/assets/outlook_calendar.png',
    dotloop: '/assets/dotloopFullLogo.png',
    trello: '/assets/trello.svg',
    outlookEmail: '/assets/outlookMail.png',
    googleEmail: '/assets/gmail.png',
    googleDrive: '/assets/driveLogo.svg',
    zillow: '/assets/zillow.png',
    fub: '/assets/fubLogo.png',
    kvcore: '/assets/kvcore-logo.png'
};

const ChatLogsDisplay = ({ clientId, clientName, isMobile = false }) => {
    const { chats } = useContext(BackendDataContext);
    const [isExpanded, setIsExpanded] = useState(true);
    // const [isLoading, setIsLoading] = useState(false);
    const [expandedMessages, setExpandedMessages] = useState(new Set());
    const [searchTerm, setSearchTerm] = useState('');

    const exportToCSV = () => {
        const headers = ['Timestamp', 'Source', 'Role', 'Message', 'APIs Used'];
        const csvData = filteredChats.map(log => {
            const logRow = renderLogRow(log);
            const sourceBadge = getSourceBadge(log.Source || log.source || 'unknown');
            const apis = logRow.apiBadges.map(badge => badge.label).join('; ');
            return [
                formatTimestamp(log.timestamp || log.TimestampUTC || new Date(), false),
                sourceBadge.label,
                log.role || '',
                (log.content || log.Content || log.Message || '').replace(/"/g, '""'),
                apis            ];
        });
        
        const csvContent = [
            headers.join(','),
            ...csvData.map(row => row.map(field => `"${field}"`).join(','))
        ].join('\n');
        
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `chat-logs-${clientName}-${new Date().toISOString().split('T')[0]}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    };

    // Helper functions
    const esc = (str = '') => {
        return String(str).replace(/[&<>"']/g, m => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#x27;'
        }[m]));
    };

    const formatTimestamp = (timestamp, isMobile = false) => {
        try {
            if (isMobile) {
                // Mobile: abbreviated format like "Aug 14, 6:37 PM"
                return new Date(timestamp).toLocaleString('en-US', { 
                    hour12: true,
                    month: 'short',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: '2-digit'
                });
            } else {
                // Desktop: full format
                return new Date(timestamp).toLocaleString('en-US', { 
                    hour12: true,
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                });
            }
        } catch {
            return esc(timestamp);
        }
    };

    const getRoleBadge = (role = '') => {
        const r = String(role).toLowerCase();
        const roleMap = {
            user: { label: 'User', class: 'b-user' },
            assistant: { label: 'Assistant', class: 'b-assistant' },
            system: { label: 'System', class: 'b-system' }
        };
        const roleInfo = roleMap[r] || { label: role || 'Other', class: 'b-other' };
        return { label: roleInfo.label, className: `badge ${roleInfo.class}` };
    };

    const getApiBadge = (apiRaw, funcName) => {
        const api = String(apiRaw || 'other').toLowerCase();
        const key = ['crm', 'google', 'outlook', 'dotloop', 'trello', 'outlookEmail', 'googleEmail', 'googleDrive', 'zillow', 'fub', 'kvcore'].includes(api) ? api : 'other';
        const label = funcName ? String(funcName) : (apiRaw || 'Other');
        const icon = API_ICON[key] || API_ICON.crm;
        return { api: key, label, icon };
    };

    const getSourceBadge = (source) => {
        const sourceData = availableSources.find(s => s.name === source) || 
                          availableSources.find(s => source && source.includes(s.name.replace('_', ''))) ||
                          { name: 'unknown', icon: '❓', label: 'Unknown' };
        return {
            name: sourceData.name,
            icon: sourceData.icon,
            label: sourceData.label
        };
    };

    const renderLogRow = (log) => {
        let raw = log.content || log.Content || log.Message || '';
        let parsed;
        
        try {
            parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
        } catch {
            parsed = null;
        }

        // Build API badges
        let apiBadges = [];
        if (parsed && Array.isArray(parsed.responses) && parsed.responses.length) {
            for (const response of parsed.responses) {
                const api = response?.api || parsed?.responseSource || 'other';
                const funcName = response?.metadata?.funcName;
                apiBadges.push(getApiBadge(api, funcName));
            }
        } else if (log.responses && Array.isArray(log.responses)) {
            for (const response of log.responses) {
                const api = response?.api || 'other';
                const funcName = response?.metadata?.funcName;
                apiBadges.push(getApiBadge(api, funcName));
            }
        }

        // Message body
        const messageBody = parsed && typeof parsed.message === 'string' 
            ? parsed.message 
            : (typeof raw === 'string' ? raw : JSON.stringify(raw));

        return {
            apiBadges,
            messageBody: esc(messageBody)
        };
    };

    const toggleMessageExpansion = (messageIndex) => {
        setExpandedMessages(prev => {
            const newSet = new Set(prev);
            if (newSet.has(messageIndex)) {
                newSet.delete(messageIndex);
            } else {
                newSet.add(messageIndex);
            }
            return newSet;
        });
    };

    const truncateMessage = (message, maxLength = 500) => {
        if (message.length <= maxLength) return message;
        return message.substring(0, maxLength) + '...';
    };

    const highlightSearchTerm = (text, searchTerm) => {
        if (!searchTerm) return text;
        
        const parts = text.split(new RegExp(`(${searchTerm})`, 'gi'));
        return parts.map((part, index) => 
            part.toLowerCase() === searchTerm.toLowerCase() 
                ? `<mark style="background: yellow; padding: 2px 4px; border-radius: 3px;">${part}</mark>`
                : part
        ).join('');
    };

    // Filter chats based on search term
    const filteredChats = chats.filter(log => {
        if (!searchTerm) return true;
        const searchLower = searchTerm.toLowerCase();
        const content = log.content || log.Content || log.Message || '';
        return content.toLowerCase().includes(searchLower) || 
               (log.role || '').toLowerCase().includes(searchLower);
    });

    // Count message types
    const userMessages = filteredChats.filter(log => String(log.role).toLowerCase() === 'user').length;
    const assistantMessages = filteredChats.filter(log => String(log.role).toLowerCase() === 'assistant').length;

    // if (isLoading) {
    //     return (
    //         <div className="chat-logs-container">
    //             <div className="loading">
    //                 <div>Loading chat logs...</div>
    //             </div>
    //         </div>
    //     );
    // }

    if (!chats || chats.length === 0) {
        return (
            <div className="chat-logs-container">
                <div className="no-logs">
                    <div className="icon">💬</div>
                    <div className="message">No chat logs found</div>
                    <div className="submessage">
                        {clientName ? `No conversations found for ${clientName}` : 'Select a client to view their chat history'}
                    </div>
                </div>
            </div>
        );
    }

    if (filteredChats.length === 0 && searchTerm) {
        return (
            <div className="chat-logs-container">
                <div className="header">
                    <div className="wrap" style={{ padding: 0 }}>
                        <h1 className="title">Chat Logs for {clientName}</h1>
                        <p className="sub">
                            Total messages: <b>{chats.length}</b>
                        </p>
                    </div>
                </div>
                
                <div className="wrap">
                    <div style={{ 
                        marginBottom: '16px', 
                        display: 'flex', 
                        gap: '12px', 
                        alignItems: 'center',
                        flexWrap: 'wrap' 
                    }}>
                        <input
                            type="text"
                            placeholder="Search messages..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{
                                flex: 1,
                                minWidth: '300px',
                                padding: '8px 12px',
                                border: '1px solid var(--border)',
                                borderRadius: '6px',
                                fontSize: '14px',
                                background: 'var(--card)',
                                color: 'var(--text)'
                            }}
                        />
                        <button 
                            onClick={() => {
                                setSearchTerm('');
                                exportToCSV();
                            }}
                            style={{
                                padding: '8px 16px',
                                background: 'var(--user)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                fontSize: '14px',
                                cursor: 'pointer',
                                fontWeight: '600'
                            }}
                        >
                            Export All
                        </button>
                    </div>

                    <div className="no-logs">
                        <div className="icon">🔍</div>
                        <div className="message">No messages match your search</div>
                        <div className="submessage">
                            Try different keywords or clear the search filter
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="chat-logs-container">
            <div className="header">
                <div className="wrap" style={{ padding: 0 }}>
                    <h1 className="title">Chat Logs for {clientName}</h1>
                    <p className="sub">
                        Total messages: <b>{chats.length}</b> • 
                        User prompts: <span style={{ color: 'var(--user)' }}><b>{userMessages}</b></span> • 
                        Assistant responses: <span style={{ color: 'var(--assistant)' }}><b>{assistantMessages}</b></span>
                    </p>
                </div>
            </div>
            
            <div className="wrap">
                <div style={{ 
                    marginBottom: '16px', 
                    display: 'flex', 
                    gap: '12px', 
                    alignItems: 'center',
                    flexWrap: 'wrap' 
                }}>
                    <input
                        type="text"
                        placeholder="Search messages..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                            flex: 1,
                            minWidth: '300px',
                            padding: '8px 12px',
                            border: '1px solid var(--border)',
                            borderRadius: '6px',
                            fontSize: '14px',
                            background: 'var(--card)',
                            color: 'var(--text)'
                        }}
                    />
                    <button 
                        onClick={exportToCSV}
                        style={{
                            padding: '8px 16px',
                            background: 'var(--user)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            fontSize: '14px',
                            cursor: 'pointer',
                            fontWeight: '600'
                        }}
                    >
                        Export CSV
                    </button>
                </div>

                <div className="summary">
                    <span className="chip">
                        User <span className="badge b-user">U</span>
                    </span>
                    <span className="chip">
                        Assistant <span className="badge b-assistant">A</span>
                    </span>
                    <span className="chip">
                        System <span className="badge b-system">S</span>
                    </span>
                    {searchTerm && (
                        <span className="chip">
                            Filtered: <strong>{filteredChats.length}</strong> of {chats.length}
                        </span>
                    )}
                </div>

                <div className="summary">
                    <span className="chip" style={{ fontSize: '12px', color: 'var(--muted)' }}>
                        Sources:
                    </span>
                    {availableSources.map(source => (
                        <span key={source.name} className="chip" style={{ fontSize: '12px' }}>
                            {source.icon} {source.label}
                        </span>
                    ))}
                </div>

                <details className="client" open={isExpanded}>
                    <summary 
                        className="client-hd" 
                        onClick={(e) => {
                            e.preventDefault();
                            setIsExpanded(!isExpanded);
                        }}
                    >
                        <div className="client-title">
                            <svg className="caret" width="12" height="12" viewBox="0 0 24 24" fill="none">
                                <path d="M8 5l8 7-8 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            {clientName}
                            <span className="client-sub">
                                • <span style={{ color: 'var(--user)' }}>{userMessages} prompts</span>, 
                                <span style={{ color: 'var(--assistant)' }}> {assistantMessages} responses</span>
                            </span>
                        </div>
                    </summary>
                    
                    <div className="client-body">
                        <table>
                            <thead>
                                <tr>
                                    <th style={{ 
                                        width: isMobile ? '80px' : '140px',
                                        minWidth: isMobile ? '80px' : '140px' 
                                    }}>
                                        {isMobile ? 'Time' : 'Timestamp'}
                                    </th>
                                    <th style={{ 
                                        width: isMobile ? '50px' : '80px',
                                        minWidth: isMobile ? '50px' : '80px' 
                                    }}>
                                        Source
                                    </th>
                                    <th style={{ 
                                        width: isMobile ? '70px' : '110px',
                                        minWidth: isMobile ? '70px' : '110px' 
                                    }}>
                                        Role
                                    </th>
                                    <th>Message</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredChats.map((log, index) => {
                                    const roleBadge = getRoleBadge(log.role);
                                    const logRow = renderLogRow(log);
                                    const sourceBadge = getSourceBadge(log.Source || log.source || 'unknown');
                                    const isMessageExpanded = expandedMessages.has(index);
                                    const isLongMessage = logRow.messageBody.length > 500;
                                    const displayMessage = isLongMessage && !isMessageExpanded 
                                        ? truncateMessage(logRow.messageBody) 
                                        : logRow.messageBody;
                                    
                                    return (
                                        <tr key={index}>
                                            <td className="ts">
                                                {formatTimestamp(log.timestamp || log.TimestampUTC || new Date(), isMobile)}
                                            </td>
                                            <td className="source" style={{ textAlign: 'center' }}>
                                                <span 
                                                    title={sourceBadge.label}
                                                    style={{
                                                        fontSize: isMobile ? '14px' : '16px',
                                                        cursor: 'help'
                                                    }}
                                                >
                                                    {sourceBadge.icon}
                                                </span>
                                            </td>
                                            <td>
                                                <span className={roleBadge.className}>
                                                    {roleBadge.label}
                                                </span>
                                            </td>
                                            <td className="msg">
                                                {logRow.apiBadges.length > 0 && (
                                                    <div className="api-badges">
                                                        {logRow.apiBadges.map((badge, badgeIndex) => (
                                                            <span 
                                                                key={badgeIndex} 
                                                                className={`api-badge api-${badge.api}`}
                                                            >
                                                                <img src={badge.icon} alt={badge.api} />
                                                                {badge.label}
                                                            </span>
                                                        ))}
                                                    </div>
                                                )}
                                                <div className="msg-block">
                                                    <pre 
                                                        style={{ 
                                                            whiteSpace: 'pre-wrap', 
                                                            fontFamily: 'inherit', 
                                                            margin: 0,
                                                            maxWidth: '100%',
                                                            wordBreak: 'break-word'
                                                        }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: highlightSearchTerm(displayMessage, searchTerm)
                                                        }}
                                                    />
                                                    {isLongMessage && (
                                                        <button 
                                                            onClick={() => toggleMessageExpansion(index)}
                                                            style={{
                                                                background: 'var(--chip)',
                                                                border: '1px solid var(--border)',
                                                                borderRadius: '4px',
                                                                padding: '4px 8px',
                                                                fontSize: '12px',
                                                                cursor: 'pointer',
                                                                marginTop: '8px',
                                                                color: 'var(--text)'
                                                            }}
                                                        >
                                                            {isMessageExpanded ? 'Show Less' : 'Show More'}
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </details>

                <div className="footer">
                    Generated by DealCompass • Admin Dashboard
                </div>
            </div>
        </div>
    );
};

export default Admin;
